import React, { useEffect } from 'react'
import ContentSection from '../../components/UI/ContentSection'
import { useTranslation } from 'react-i18next'
import Plan from '../../components/Subscription/Plan/Plan'
import Invoices from '../../components/Subscription/Invoices/Invoices'
import PlanBanners from '../../components/Subscription/PlanBanners'

const PlanAndBilling = () => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = `${t('planAndBilling')} - ReportAll`
  }, [t])

  return (
    <ContentSection>
      <PlanBanners />
      <Plan />
      <Invoices />
    </ContentSection>
  )
}

export default PlanAndBilling
